export const EventBroadcastOverlayStyleKeys = {
  overlay_plain: 'overlay_plain',
  overlay_image: 'overlay_image',
}
